import '../App.css';
import React from 'react';
import { write, useSnap } from '../store'
// import Lottie from "lottie-react";
import toast from 'react-hot-toast';
// import { ClipboardEvent } from "react"
// import { WsContext } from '../App'
import { pack } from 'msgpackr';
import { locale } from './locale';
import posthog from 'posthog-js';


function Writing({ dataPath }) {
    const read = useSnap()
    // const [allWords, setAllWords] = React.useState('out');
    const [wordControl, setWordControl] = React.useState(0);
    const ws = read.ws


    React.useEffect(() => {
        write.writingAllWords = ''
        if (read.instruction[read.questions[read.currentQuestion - 1].questionType]) {
            write.stopTimer = false
        }
    }, [read.currentQuestion, read.instruction, read.questions]);


    // console.log(read.instruction[read.questions[read.currentQuestion - 1].questionType], !read.stopTimer, '🍀🍀🍀')

    React.useEffect((e) => {
        wordControl <= 80 && setWordControl(read.writingAllWords.toString().split(" ").length - 1);
    }, [read.writingAllWords, wordControl])

    const preventCopyPaste = (e) => {
        e.preventDefault()
        toast.error('Pasting is not allowed on this platform. Please use your own knowledge to write the text. ❌', { duration: 3333 })
    }

    function handleSend() {
        posthog.capture('writing_answer_submitted', {
            invitation_id: read.id,
            question_index: read.currentQuestion - 1,
            word_count: wordControl,
        });
        setTimeout(() => {
            ws.send(pack({ type: 'ONE_ANSWER', id : read.id , data: read.writingAllWords, index: read.currentQuestion - 1 }))
            write.loading = true
        }, 999);
    }



    // console.log('WRITINGNGG ' , read.writingAllWords)

    return (
        <>
            <div className='flex w-full flex-col items-center'>
                <label htmlFor="message" className="mb-2 block text-sm font-bold text-slate-700 dark:text-gray-400">
                    {locale[read.user.language].button.wordCount} : <span className={wordControl < 80 ? 'text-red-600' : 'text-green-500'}>{wordControl}</span></label>
                <textarea spellCheck={false} onChange={(e) => write.writingAllWords = e.currentTarget.value} onPaste={preventCopyPaste} id="message" rows={10} className="question-writing-input mb-3 block w-full resize-none rounded-2xl border border-slate-300 bg-white p-4 text-base leading-7 text-slate-900 shadow-inner shadow-slate-900/5 focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500" placeholder="Your message..." defaultValue={""} />
                { // should be >= with wordControl
                    wordControl >= 80 ? <button onClick={handleSend} type="button" className="mb-2 min-h-[48px] w-full rounded-2xl bg-blue-700 px-5 py-3 text-center text-sm font-black uppercase tracking-[0.14em] text-white shadow-lg shadow-blue-700/20 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 sm:w-auto sm:min-w-[12rem]">{locale[read.user.language].button.send}</button> : <button disabled type="button" className="mb-2 min-h-[48px] cursor-not-allowed rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-500 focus:outline-none focus:ring-4 focus:ring-slate-200 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400 dark:focus:ring-gray-700">{80 - wordControl} {locale[read.user.language].button.moreWords}</button>
                }
            </div>
            <pre className=' w-fit cursor-pointer hidden' onClick={handleSend}>{locale[read.user.language].button.skip}</pre>
        </>
    );
}

export default Writing;
